import { render } from "./DeviceContainer.vue?vue&type=template&id=5882b20e"
import script from "./DeviceContainer.vue?vue&type=script&lang=js"
export * from "./DeviceContainer.vue?vue&type=script&lang=js"

import "./DeviceContainer.vue?vue&type=style&index=0&id=5882b20e&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__